// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"448":"03d983b7f1b553e6","773":"3bb799fa4da2eac1"}[chunkId] + ".js";
};